export const situacoes = [
  {
    label: "Sem Manifestação",
    nome: "SEM_MANIFESTACAO",
    cor: "#BFBFBF",
  },
  {
    label: "Confirmação da operação",
    nome: "CONFIRMACAO",
    cor: "#4FBB53",
  },
  {
    label: "Ciência da emissão",
    nome: "CIENCIA",
    cor: "#004780",
  },
  {
    label: "Desconhecimento da operação",
    nome: "DESCONHECIMENTO",
    cor: "#DC3545",
  },
  {
    label: "Operação não realizada",
    nome: "NAO_REALIZADA",
    cor: "#EA9D2B",
  },
];